import variables from '../variables-styles.module.scss';
import {
  floormapHeatBeanCount,
  floormapLegendColors,
  floormapMergedNeutralColor,
  floormapMergedNeutralLightColor,
} from 'common/floormapHeat';

type HeatBeanRating = {
  color: string;
  light_color: string;
  label: string;
  label_volatility: string;
  is_show: boolean;
  text_lbl_volatility: string;
  text_sleeper_slot: number | string;
};

export const heatBeanRatings: { [key: number]: HeatBeanRating } = {
  6: {
    color: variables.hotColor,
    light_color: `rgba(${variables.hotColor}, 0.2)`,
    label: 'High',
    label_volatility: 'High',
    is_show: true,
    text_lbl_volatility: 'High',
    text_sleeper_slot: 6,
  },
  5: {
    color: variables.warmColor,
    light_color: `rgba(${variables.warmColor},0.2)`,
    label: '',
    label_volatility: '',
    is_show: true,
    text_lbl_volatility: 'High',
    text_sleeper_slot: 5,
  },
  4: {
    color: variables.neutralWarmColor,
    light_color: `rgba(${variables.neutralWarmColor}, 0.2)`,
    label: '',
    label_volatility: '',
    is_show: true,
    text_lbl_volatility: 'Medium',
    text_sleeper_slot: 4,
  },
  3: {
    color: variables.neutralColdColor,
    light_color: `rgba(${variables.neutralColdColor}, 0.2)`,
    label: '',
    label_volatility: '',
    is_show: true,
    text_lbl_volatility: 'Medium',
    text_sleeper_slot: 3,
  },
  2: {
    color: variables.coldColor,
    light_color: `rgba(${variables.coldColor}, 0.2)`,
    label: '',
    label_volatility: '',
    is_show: true,
    text_lbl_volatility: 'Low',
    text_sleeper_slot: 2,
  },
  1: {
    color: variables.veryColdColor,
    light_color: `rgba(${variables.veryColdColor}, 0.2)`,
    label: 'Low',
    label_volatility: 'Low',
    is_show: true,
    text_lbl_volatility: 'Low',
    text_sleeper_slot: 1,
  },
  0: {
    color: 'hsl(0,0%,50%)',
    light_color: 'hsla(0,0%,50%,0.2)',
    label: '',
    label_volatility: '',
    is_show: false,
    text_lbl_volatility: '',
    text_sleeper_slot: '',
  },
};

const isFiveBeanFloormap = floormapHeatBeanCount === 5;

const getFloormapHeatBeanRating = (heatLevel: number): HeatBeanRating => {
  if (!isFiveBeanFloormap) {
    return heatBeanRatings[heatLevel];
  }

  const withLegendColor = (base: HeatBeanRating, level: 5 | 4 | 3 | 2 | 1): HeatBeanRating => {
    const color = floormapLegendColors[level];
    return {
      ...base,
      color,
      light_color: `rgba(${parseInt(color.slice(1, 3), 16)}, ${parseInt(color.slice(3, 5), 16)}, ${parseInt(color.slice(5, 7), 16)}, 0.2)`,
      text_sleeper_slot: level,
    };
  };

  switch (heatLevel) {
    case 6:
      return {
        ...heatBeanRatings[6],
        is_show: false,
      };
    case 5:
      return withLegendColor(heatBeanRatings[6], 5);
    case 4:
      return withLegendColor(heatBeanRatings[5], 4);
    case 3:
      return withLegendColor(
        {
          ...heatBeanRatings[4],
          color: floormapMergedNeutralColor,
          light_color: floormapMergedNeutralLightColor,
        },
        3
      );
    case 2:
      return withLegendColor(heatBeanRatings[2], 2);
    case 1:
      return withLegendColor(heatBeanRatings[1], 1);
    default:
      return heatBeanRatings[heatLevel];
  }
};

export const floormapHeatBeanRatings: { [key: number]: HeatBeanRating } = {
  6: getFloormapHeatBeanRating(6),
  5: getFloormapHeatBeanRating(5),
  4: getFloormapHeatBeanRating(4),
  3: getFloormapHeatBeanRating(3),
  2: getFloormapHeatBeanRating(2),
  1: getFloormapHeatBeanRating(1),
  0: heatBeanRatings[0],
};

export const hotColdRatings = {
  6: heatBeanRatings[6],
  1: heatBeanRatings[1],
  0: heatBeanRatings[0],
};

const jackpotGoldTop    = '#FFFEA5';
const jackpotGoldMid    = '#FFBD60';
const jackpotGoldBottom = '#CC7D2E';

export const floormapJackpotHeatBeanRatings: { [key: number]: HeatBeanRating } = {
  6: { ...floormapHeatBeanRatings[6], is_show: false },
  5: { ...floormapHeatBeanRatings[5], color: jackpotGoldTop,    light_color: 'rgba(255, 254, 165, 0.2)' },
  4: { ...floormapHeatBeanRatings[4], color: jackpotGoldMid,    light_color: 'rgba(255, 189, 96, 0.2)' },
  3: { ...floormapHeatBeanRatings[3], color: jackpotGoldBottom, light_color: 'rgba(204, 125, 46, 0.2)' },
  2: { ...floormapHeatBeanRatings[2] },
  1: { ...floormapHeatBeanRatings[1] },
  0: heatBeanRatings[0],
};
